const mapElement = document.querySelector('.zpif-map');
if (mapElement) {
    //на открытие карты
    const mapTogglers = document.querySelectorAll('.js-map-toggle');
    mapTogglers.forEach((toggler) => {
        toggler.addEventListener('click', function () {
            mapElement.classList.toggle('hidden');
            document.querySelector('body').classList.toggle('hidden-scroll');
        })
    })
    const menuMobileToggle = mapElement.querySelector('.js-open-map-menu-mobile');
    if (menuMobileToggle) {
        menuMobileToggle.addEventListener('click', function () {
            menuMobileToggle.parentElement.classList.toggle('menu-opened');
        })
    }
}

//Инициализация карты
ymaps.ready(init);

function init() {
   const myMap = new ymaps.Map('map', {
        center: [59.952885, 30.290706],
        zoom: 12,
        controls: []
    }, {
        searchControlProvider: 'yandex#search'
    });// Контейнер для меню.
    menu = document.querySelector('.js-catalog')

    for (let i = 0, l = groups.length; i < l; i++) {
        createMenuGroup(groups[i]);
    }
    function createMenuGroup(group) {
        // Коллекция для геообъектов группы.
        let collection = new ymaps.GeoObjectCollection(null, { preset: group.style });
        // Добавляем коллекцию на карту.
        myMap.geoObjects.add(collection);
        // По клику удаляем/добавляем коллекцию на карту
        for (let j = 0, m = group.items.length; j < m; j++) {
            createSubMenu(group.items[j], collection, menu);
        }
    }

    function createSubMenu(item, collection, menu) {
        const catalog = document.querySelector('.js-catalog');
        const menuMobileToggle = catalog.querySelector('.js-open-map-menu-mobile');

        let submenuItem = document.createElement('a');
            submenuItem.href = 'javascript:;';
            submenuItem.className = 'catalog-item';

            submenuItem.innerHTML = `
                <div class="item-wrapper js-map-item">
                    <span class="map-h4">
                        <img class="lazy" src="/assets/src/assets/img/icon/map-marker.svg" alt="значок карты">
                        ${item.name}
                    </span>
                    <p>Застройщик</p>
                    <div class="map-h5">${item.builder}</div>
                </div>
            `;

        placemark = new ymaps.Placemark(item.center, {
            balloonContent:
                `<div class="object-info">
                    <div class="object-info__card">
                        <img src="/assets/src/assets/img/zpif/map/${item.image}" alt="Реализованные объекты">
                        <div class="object-info__card--description">
                            <p class="title">${item.name}</p>
                            <p class="info-text"><span>Застройщик:</span>${item.builder}</p>
                            <p class="info-text">${item.description}</p>
                        </div>
                    </div>
                </div >`,
        },{
            // Опции.
            iconLayout: 'default#image',
            iconImageHref: 'assets/src/assets/img/icon/map-marker-close.svg',
            iconImageSize: [16, 16],
            //Не скрываем точку при открытии балуна
            hideIconOnBalloonOpen: false,
            // Смещение левого верхнего угла иконки относительно
            // её "ножки" (точки привязки).
            iconImageOffset: [-8, 0]
        });

        placemark.events.add('balloonopen', function (e) {
            submenuItem.querySelector('.js-map-item').classList.add('active');

            if (window.innerWidth > 1024) {
                submenuItem.scrollIntoView();
            }
        })
        placemark.events.add('balloonclose', function (e) {
            let activeElement = catalog.querySelector('.active');
            if (activeElement) {
                activeElement.classList.remove('active');
            }
        })

        // Добавляем метку в коллекцию.
        collection.add(placemark);

        // Добавляем пункт в подменю.
        submenuItem.addEventListener('click', function (event) {
          event.preventDefault();
          if (!placemark.balloon.isOpen()) {
              placemark.balloon.open();
              if (menuMobileToggle) {
                  menuMobileToggle.parentElement.classList.remove('menu-opened');
                  if (window.innerWidth < 1024) {
                      menuMobileToggle.parentElement.scrollTop = 0;
                  }
              }
          } else {
              placemark.balloon.close();
          }
      });
      menu.appendChild(submenuItem);
    }
}

// Группы объектов и данные по ним
const groups = [
    {
        name: "Объекты, построенные с помощью ЗПИФ",
        style: "islands#redIcon",
        items: [
            {
                center: [59.917326, 30.515195],
                name: "ЖК Капитал",
                image: "object-1-capital.png",
                builder: "Компания «Строительный трест»",
                description: `Общая площадь – более 520 000 кв.метров`
            },
            {
                center: [59.807948, 30.086798],
                name: "ЖК NEWПИТЕР",
                image: "object-2-newpiter.png",
                builder: "Компания «Строительный трест»",
                description: `Часть корпусов в крупном ЖК. Общая площадь – более 350 000 кв.метров`
            },
            {
                center: [59.847268, 30.415940],
                name: "ЖК «Новое Купчино»",
                image: "object-3-new-kupchino.png",
                builder: "Компания «Строительный трест»",
                description: `Общая площадь – более 200 000 кв. метров`
            },
            {
                center: [55.903978, 37.877796],
                name: "ЖК «Парад планет»",
                image: "object-4-parad-planet.png",
                builder: "Компания «С-СтройПерспектива»",
                description: `Общая площадь – более 144 000 кв.метров`
            },
            {
                center: [60.028928, 30.330511],
                name: "ЖК «Сергей Есенин»",
                image: "object-5-esenin.png",
                builder: "Компания «Строительный трест»",
                description: `Общая площадь – более 110 000 кв.метров`
            },
            {
                center: [60.068857, 30.313631],
                name: "ЖК «Континенты»",
                image: "object-6-continents.png",
                builder: "Компания «КВС»",
                description: `Общая площадь – более 100 000 кв.метров`
            },
            {
                center: [60.028357, 30.337185],
                name: "ЖК «Лиственный»",
                image: "object-7-leaf.png",
                builder: "Компания «Строительный трест»",
                description: `Общая площадь – более 105 000 кв. метров`
            },
            {
                center: [60.014185, 30.311394],
                name: "ЖК «Невский стиль»",
                image: "object-8-nevskiy.png",
                builder: "Компания «Строительный трест»",
                description: `Общая площадь – более 95 000 кв.метров`
            },
            {
                center: [59.939771, 30.353184],
                name: "ЖК Русский дом",
                image: "object-9-russian-house.png",
                builder: "Компания ЛСР",
                description: `
                    Лучшая архитектурная концепция по версии Urban Awards 2017.
                    Общая площадь – более 92 000 кв.метров`
            },
            {
                center: [59.917799, 30.512033],
                name: "ЖК Архитектор",
                image: "object-10-architect.png",
                builder: "Компания «Строительный трест»",
                description: `Общая площадь – более 89 000 кв.метров`
            },
            {
                center: [59.959237, 30.272210],
                name: "ЖК «OSTROV»",
                image: "object-11-island.png",
                builder: "Компания «Строительный трест»",
                description: `
                    ЖК на Васильевском острове.
                    Общая площадь – более 75 000 кв.метров.`
            },
            {
                center: [59.972060, 30.394794],
                name: "ЖК «Золотое сечение»",
                image: "object-12-golden.png",
                builder: "Компания «Строительный трест»",
                description: `Общая площадь – более 53 000 кв.метров`
            },
            {
                center: [60.032578, 30.404954],
                name: "ЖК «Ломоносов»",
                image: "object-13-lomonosov.png",
                builder: "Компания «Строительный трест»",
                description: `Общая площадь – более 50 000 кв.метров`
            },
            {
                center: [60.023488, 30.327986],
                name: "ЖК «Сосновка»",
                image: "object-14-sosnovka.png",
                builder: "Компания «Строительный трест»",
                description: `Общая площадь – более 50 000 кв.метров`
            },
            {
                center: [60.105980, 29.973646],
                name: "ЖК «Пляж»",
                image: "object-15-beach.png",
                builder: "Компания «Строительный трест»",
                description: `Общая площадь – более 29 000 кв.метров`
            },
            {
                center: [59.963611, 30.287149],
                name: "Апарт-отель Grani",
                image: "object-16-grani.png",
                builder: "Компания «Строительный трест»",
                description: `Общая площадь – более 32 000 кв.метров`
            },
            {
                center: [59.952885, 30.290706],
                name: "Апарт-отель Avatar",
                image: "object-17-avatar.png",
                builder: "Компания «Строительный трест»",
                description: `Общая площадь – более 20 000 кв.метров`
            },
            {
                center: [59.888244, 29.855839],
                name: "Коттеджные поселки «Сад времени» и «Небо»",
                image: "object-18-timegarden.png",
                builder: "Компания «Строительный трест»",
                description: `Общая площадь – около 30 га`
            },
            {
                center: [59.960534, 30.288559],
                name: "Family Loft",
                image: "object-19-familyloft.png",
                builder: "Компания «Bronka»",
                description: `Общая площадь – 6500 кв.метров`
            }
        ]
    }
];